import Vue from 'vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue';
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
import $ from 'jquery'
import axios from "axios";
import JsonExcel from 'vue-json-excel'
import vSelect from 'vue-select'
import Header from "../../components/Header.vue";
import {debounce} from "lodash";
import moment from "moment";
import ExportExcel from "../../components/ExportExcel.vue";

Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select', vSelect)


export default {
    components: {
        ExportExcel,
        Header,
        Vuetable,
        VuetablePagination,
        VuetableFieldCheckbox,
        VuetableFieldMixin
    },
    data: function() {
        return {
            pageTitle: "Liste des tresoreries",
            initialPage: parseInt(this.$route.query.page) > 0 ? parseInt(this.$route.query.page) : 1,
            type_submit :"insertion",
            vuetable: {
                moreParams: {
                    start_date: moment().startOf('month').format('DD/MM/YYYY'),
                    end_date:  moment().endOf('month').format('DD/MM/YYYY'),
                    filter: '',
                    nom_client: '',
                    criteriacol: '',
                },
                fields: [
                    {
                        name: 'date_paiement_formatted',
                        title: 'Date',
                        sortField: 'date_paiement',
                        dataClass: 'text-left',
                        width: "100px"
                    },
                    {
                        name: 'numero_bl',
                        title: 'N° BL',
                        sortField: 'numero_bl',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'nom_client',
                        title: 'Client',
                        sortField: 'nom_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'transporteur',
                        title: 'Transpoteur',
                        sortField: 'transporteur',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'numero_transporteur',
                        title: 'N° Transporteur',
                        sortField: 'numero_transporteur',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'destination',
                        title: 'Destination',
                        sortField: 'destination',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'nbre_conteneur',
                        title: 'Nbre Conteneur',
                        sortField: 'nbre_conteneur',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'tc',
                        title: 'Tc',
                        sortField: 'tc',
                        dataClass: 'text-right',
                        titleClass: 'text-right',
                    },
                    {
                        name: 'commentaire',
                        title: 'Commentaire',
                        sortField: 'commentaire',
                        dataClass: 'text-left',
                    },
                    {
                        name: 'montant_payer',
                        title: 'Montant Payer',
                        sortField: 'montant_payer',
                        dataClass: 'text-right',
                        titleClass: 'text-right',
                    },
                    {
                        name: 'actions',
                        title: '-',
                        titleClass: 'text-center column_fixed-header',
                        width: "80px",
                        dataClass: "text-center  column_fixed",
                        is_excel: 'false'
                    }

                ],
                sortOrder: [
                    { field: 'id', direction: 'asc' }
                ],
                css: {
                    table: {
                        // tableClass: 'table table-striped table-bordered table-hovered',
                        tableClass: 'table-responsive text-nowrap w-100 d-block d-md-table table table-bordered table-hover',
                        loadingClass: 'loading',
                        ascendingIcon: 'fas fa-arrow-up fa-sm',
                        descendingIcon: 'fas fa-arrow-down fa-sm',
                        handleIcon: 'fas fa-bars fa-sm',
                    },
                    pagination: {
                        infoClass: 'pull-left ',
                        wrapperClass: 'vuetable-pagination text-center',
                        activeClass: 'btn-secondary',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        },
                    }
                },
            },
            exportexcel: {
                json_fields: {
                    'Nom de la Tresorerie': 'nom_poste_depense',
                    'Type de la Tresorerie': 'type_tresorerie',
                    'Solde': 'solde',
                    'Nom du compte': 'nom_compte',
                    'Numero du compte': 'numero_compte',
                    'BIC': 'bic',
                    'IBAN': 'iban',
                    'BANQUE Correspondante': 'banque_correspondante',
                    'Code swift': 'code_swift',
                    'Utilisateur associé': 'nom'

                },
                json_data: [],
                json_meta: [
                    [{
                        'key': 'charset',
                        'value': 'utf-8'
                    }]
                ],
            },
            motCle: "",
            crudform: {
                id: "",
                nom_client: "",
                id_client: "",
                id_dossier: "",
                transporteur: "",
                destination: "",
                numero_transporteur: "",
                date_paiement: "",
                date_paiement_formatted: moment().format('DD/MM/YYYY'),
                tc: "",
                commentaire: "",
                numero_bl: "",
                montant_payer: 0,
                nbre_conteneur: 0,
            },
            dateOptions:{
                format: 'DD/MM/YYYY'
            },
            crudmodaltitle: "Nouveau",
            list_BL: [],
            list_client: [],
            list_transporteur: [],
            btn_submit:false,
            filtre: {
                recherche: '',
                start_date: moment().startOf('month').format('DD/MM/YYYY'),
                end_date:  moment().endOf('month').format('DD/MM/YYYY'),
                nom_client: '',
                criteriacol: '',
            }
        }
    },
    methods: {
        fetchTransporteur(recherche){
            const formmulaire = new FormData();
            formmulaire.append("recherche", recherche);

            axios.post(this.BASE_URL + "/suivietransport/fetch", formmulaire)
                .then((response) => {
                    this.list_transporteur = response.data;
                })
                .catch((err) => console.error(err));
        },

        fetchCLientByBL(){
            let formulaire = new FormData();
            formulaire.append('numero_bl', this.crudform.numero_bl);
            axios.post(this.BASE_URL+"/dossier/fetchclientbybl", formulaire).then((response) => {
                this.crudform.id_client = response.data.id_client;
                this.list_client = response.data.list_client;
            })
        },
        onSearchBl: debounce(function (query) {
            if (query && query.length > 1) {
                this.fetchBlList(query);
            }
        }, 400),

        fetchBlList(recherche) {
            const formmulaire = new FormData();
            formmulaire.append("recherche", recherche);
            axios.post(this.BASE_URL + "/dossier/fetch", formmulaire)
                .then((response) => {
                    this.list_BL = response.data;
                })
                .catch((err) => console.error(err));
        },
        fetchDefaultClients(){
            const formmulaire = new FormData();
            formmulaire.append("recherche", '');

            axios.post(this.BASE_URL + "/client/fetch", formmulaire)
                .then((response) => {
                    this.list_client = response.data;
                })
                .catch((err) => console.error(err));
        },
        fetchClientList(recherche) {
            const formmulaire = new FormData();
            formmulaire.append("recherche", recherche);

            axios.post(this.BASE_URL + "/client/fetch", formmulaire)
                .then((response) => {
                    this.list_client = response.data;
                })
                .catch((err) => console.error(err));
        },
        onSearchClient: debounce(function (query) {
            this.fetchClientList(query);
        }, 400),



        onRowClass(dataItem, index) {
            if (index == "") console.log("");

            if(Number(dataItem.solde) < 0) {
                // return 'text-danger text-bold';
            }
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
            this.syncFiltersToUrl(paginationData.current_page);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        editRow(rowData) {
            //alert("You clicked edit on" + JSON.stringify(rowData))
            axios.get(this.BASE_URL + "/suivietransport/get/" + rowData.id).then(response => {
                this.crudform = response.data.data[0];
                this.list_client = response.data.list_client;

                this.crudmodaltitle = "Editer";
                this.openModal();
                this.type_submit="update";
            });

        },
        deleteRow(rowData) {
            //alert("You clicked delete on" + JSON.stringify(rowData));
            var that = this;
            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment supprimer cette ligne?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Supprimer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        axios.post(that.BASE_URL + "/suivietransport/delete/" + rowData.id).then(function(response) {
                            console.log(response);
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log(response.data.message);
                                that.setFilter();
                                Vue.$toast.open({
                                    message: response.data.message,
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                })

        },
        onLoading() {
            console.log('loading... show your spinner here')
        },
        onLoaded() {
            console.log('loaded! .. hide your spinner here');
        },
        applyFiltersToParams() {
            this.vuetable.moreParams.filter = this.filtre.recherche;
            this.vuetable.moreParams.criteriacol = this.filtre.criteriacol;
            this.vuetable.moreParams.start_date = this.filtre.start_date;
            this.vuetable.moreParams.end_date = this.filtre.end_date;
            this.vuetable.moreParams.nom_client = this.filtre.nom_client;
        },
        syncFiltersToUrl(currentPage) {
            const query = {};
            if (this.filtre.recherche !== "") query.filter = this.filtre.recherche;
            if (this.filtre.criteriacol !== "") query.criteriacol = this.filtre.criteriacol;
            if (this.filtre.nom_client !== "") query.nom_client = this.filtre.nom_client;
            if (this.filtre.start_date !== "") query.start_date = this.filtre.start_date;
            if (this.filtre.end_date !== "") query.end_date = this.filtre.end_date;
            if (parseInt(currentPage) > 1) query.page = String(currentPage);

            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({ query }).catch(() => {});
            }
        },
        setFilter() {
            this.applyFiltersToParams();
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        resetFilter() {
            this.filtre= {
                recherche: '',
                start_date: moment().startOf('month').format('DD/MM/YYYY'),
                end_date:  moment().endOf('month').format('DD/MM/YYYY'),
                nom_client: '',
                criteriacol: '',
            };
            this.setFilter();
        },
        onExport() {

            this.exportexcel.json_data = this.$refs.vuetable.$data.tableData;
            $("#excel-download").trigger("click");
        },
        openModal() {
            this.fetchData();
            this.$bvModal.show("crudmodal");

        },
        closeModal() {
            this.$bvModal.hide("crudmodal");
        },
        addRow() {
            this.crudmodaltitle = "Nouveau";
            this.crudform = {
                id: "",
                nom_client: "",
                id_client: "",
                id_dossier: "",
                transporteur: "",
                destination: "",
                numero_transporteur: "",
                date_paiement: "",
                date_paiement_formatted: moment().format('DD/MM/YYYY'),
                tc: "",
                commentaire: "",
                numero_bl: "",
                montant_payer: 0,
                nbre_conteneur: 0,
            };
            this.type_submit= 'insert'
            // console.log(this.crudform);
            this.openModal();
        },
        onSubmit() {
            var that = this;

            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment continuer l\'enregistrement?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Continuer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        var link = '';
                        that.btn_submit = true;

                        link = that.type_submit == 'insert' ? that.BASE_URL + "/suivietransport/addaction" : that.BASE_URL + "/suivietransport/editaction";

                        axios.post(link, $("#formulaire").serialize()).then(function(response) {
                            console.log(response);
                            that.btn_submit = false;
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log("Enregistrement effectué avec succès!");
                                that.closeModal();
                                that.setFilter();
                                Vue.$toast.open({
                                    message: 'Enregistrement effectué avec succès!',
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                });
        },
        fetchData: function() {
            axios.get(this.BASE_URL + "/tresoreries/fetchdata").then(response => {
                console.log(response)
                this.listdata = response.data;
            });
        }
    },

    created: function() {
        this.$emit('change-page', this.pageTitle);
        const query = this.$route.query;
        this.filtre = {
            recherche: query.filter || "",
            start_date: query.start_date || moment().startOf('month').format('DD/MM/YYYY'),
            end_date: query.end_date || moment().endOf('month').format('DD/MM/YYYY'),
            nom_client: query.nom_client || "",
            criteriacol: query.criteriacol || "",
        };
        this.applyFiltersToParams();
    },
    mounted: function() {
        this.fetchBlList('');
        this.fetchTransporteur('');
        this.fetchDefaultClients();
    }
}
